import ThemeModeToggle from './ThemeModeToggle';
import ThemeColorPicker from './ThemeColorPicker';

export default function ThemeSelector() {
  return (
    <div className="flex items-center gap-2">
      <ThemeModeToggle />
      <ThemeColorPicker />
    </div>
  );
}
